/* eslint-disable */
import {VideoPlayer} from './VideoPlayer';
import {DetailedProduct} from './DetailedProduct';
import {ConfiguratorBase} from './ConfiguratorBase';
import {ContentArea} from './ContentArea';
import {LeaderBoardAd} from './LeaderBoardAd';
import {Picture} from './Picture';
import {ListViewProduct} from './ListViewProduct';
import {RelatedListViewProduct} from './RelatedListViewProduct';
import {AddonServices} from './AddonServices';
import {ProductReview} from './ProductReview';
import {TopSellerBlock} from './TopSellerBlock';
import {RelatedProduct} from './RelatedProduct';
import {SampleProduct} from './SampleProduct';
import {PackageProduct} from './PackageProduct';
import {ReactComponent} from './ReactComponent';
import {BreadcrumbsStructuredDataRoot} from './BreadcrumbsStructuredDataRoot';
import {EnticementDto} from './EnticementDto';
import {LoadingStatus} from './LoadingStatus';
import {PriceGuaranteeModel} from './PriceGuaranteeModel';
import {RedReview} from './RedReview';
import {RatingPerLevel} from './RatingPerLevel';
import {RedReviews} from './RedReviews';
import {BundleProductLink} from './BundleProductLink';
import {AddonGroup} from './AddonGroup';
import {ApptusPageModel} from './ApptusPageModel';
/**
* @description Interface for Avensia.Commerce.Web.src.views.ProductPage.ProductPageModel
*/
export interface ProductPageModel extends ApptusPageModel {
	video: VideoPlayer;
	product: DetailedProduct;
	configurator?: ConfiguratorBase;
	topContentArea?: ContentArea;
	leaderboardAd?: LeaderBoardAd;
	brandLogo?: Picture;
	seriesFilter?: string;
	productsInSeries?: ListViewProduct[];
	othersAlsoBoughtProducts?: RelatedListViewProduct[];
	addons?: Record<string, AddonGroup>;
	addonServices?: AddonServices;
	reviews?: ProductReview[];
	recommended?: ListViewProduct[];
	topSellers?: TopSellerBlock;
	accessories?: RelatedProduct[];
	samples?: SampleProduct[];
	bundledProduct?: RelatedProduct;
	packageProduct?: PackageProduct;
	efficiencyLabel?: ReactComponent[];
	showProductAdded: boolean;
	offerLink?: string;
	adminProperties?: Record<string, string>;
	breadCrumbsStructured?: BreadcrumbsStructuredDataRoot[];
	enticement?: EnticementDto;
	isBot: boolean;
	variantLoadingStatus: LoadingStatus;
	shouldUseNotifyMe: boolean;
	priceGuarantee?: PriceGuaranteeModel;
	/**
    * @version - Property is marked as versioned and might not exist for usage
    **/
    mostPopularReview?: RedReview;
	/**
    * @version - Property is marked as versioned and might not exist for usage
    **/
    ratingsPerLevel?: RatingPerLevel[];
	/**
    * @version - Property is marked as versioned and might not exist for usage
    **/
    redReviews?: RedReviews;
	bundleProductLinks: BundleProductLink[];
}
export const isProductPage = (model: unknown): model is ProductPageModel => (model as ProductPageModel).componentName === 'ProductPage';
